import { render, staticRenderFns } from "./SettingsLocalisationRegionsIgnoreRequirements.vue?vue&type=template&id=1a336f95&"
import script from "./SettingsLocalisationRegionsIgnoreRequirements.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocalisationRegionsIgnoreRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports